export default "__VITE_ASSET__CpUkwqqr__"